import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import AccountsIcon from '@material-ui/icons/AccountBalanceOutlined';
import Paginator from '../../../components/Paginator/Paginator';
import BaseDialog from '../../../components/BaseDialog/BaseDialog';

import {
  getString,
  stringToCurrency,
  stringToDateCompact,
} from '../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';
import { Typography } from '@material-ui/core';

const stringsComponent = 'arrangementsSchedule';

class ArrangementSchedule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      itemsPerPage: 10,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(currentPage) {
    this.setState({ page: currentPage });
  }

  render() {
    const { classes, open, handleClose, items, balance, theme } = this.props;

    const { page, itemsPerPage } = this.state;

    // Logic for displaying current todos
    const lastItemIndex = page * itemsPerPage;
    const firstItemIndex = lastItemIndex - itemsPerPage;
    const currentItems = items.slice(firstItemIndex, lastItemIndex);

    return (
      <BaseDialog
        open={open}
        largeTitle={true}
        title={getString(stringsComponent, 'DIALOG_TITLE')}
        content={
          <React.Fragment>
            <Grid container>
              <Grid item xs={8} className={classes.totalLabel}>
                <Typography className={classes.totalText}>
                  {getString(stringsComponent, 'TOTAL_LABEL')}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.totalValue}>
                <Typography className={classes.totalText}>
                  ${balance}
                </Typography>
              </Grid>
            </Grid>
            <Table>
              <TableHead>
                <TableRow>
                  <Hidden xsDown>
                    <TableCell className={classes.tableCellHead}>
                      {getString(stringsComponent, 'NUMBER_LABEL')}
                    </TableCell>
                  </Hidden>
                  <TableCell className={classes.tableCellHead}>
                    {getString(stringsComponent, 'DATE_LABEL')}
                  </TableCell>
                  <TableCell className={classes.tableCellHead}>
                    {getString(stringsComponent, 'AMOUNT_LABEL')}
                  </TableCell>
                  <TableCell align='right' className={classes.tableCellHead}>
                    {getString(stringsComponent, 'BALANCE_LABEL')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.transactionsTableBody}>
                {currentItems.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <Hidden xsDown>
                        <TableCell className={classes.tableCell}>
                          {item.number}
                        </TableCell>
                      </Hidden>
                      <TableCell className={classes.tableCell}>
                        {stringToDateCompact(item.date)}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {stringToCurrency(item.amount)}
                      </TableCell>
                      <TableCell align='right' className={classes.tableCell}>
                        {stringToCurrency(item.balance)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <Paginator
              rootClassName={classes.paginator}
              onChange={this.handleChange}
              itemsCount={items.length}
              itemsPerPage={itemsPerPage}
            />
          </React.Fragment>
        }
        contentWrap={false}
        buttonAction={() => {
          this.setState({ page: 1 });
          handleClose();
        }}
        buttonLabel={getString('app', 'CLOSE_LABEL')}
        icon={AccountsIcon}
        iconColour={theme.palette.custom.accounts}
        inlineTitle={true}
      />
    );
  }
}

ArrangementSchedule.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  balance: PropTypes.number.isRequired,
};

ArrangementSchedule.defaultProps = {};

export default withStyles(styles, { withTheme: true })(ArrangementSchedule);
